// @flow
import modularui from "../_modularui/ModularUIConnector";

import type { ModularUIConnector } from "../_modularui/types";

/**
 * @deprecated - will be removed in the future, use the equivalent hook 'useCaseView' instead
 */
export const connectCaseView: ModularUIConnector = modularui(
  "CaseView",
  ({ match }) => match.url,
  {
    propName: "caseview",
  },
);
